export function removerFormatacao(documento: string): string {
  return documento.replace(/[.\-/]/g, '');
}
